module.exports = __webpack_public_path__ + "img/2025-08-16d_1.1dc9d84a.jpg";